import { Maybe, useRequiredContext } from "@ispb/react-hooks"
import { Fragment } from "react"
import { Badge, Container, Nav, Navbar } from "react-bootstrap"
import { When } from "react-if"
import { NavLink } from "react-router-dom"
import { ASSET_DELIMITER } from "shared/misc"
import IconText from "ui/components/IconText"
import { FLUID_AT } from "ui/config"
import { EXECUTE_ICON, LOGOUT_ICON, VIEW_ICON } from "ui/icons"
import { PublicProcedureContext, useAnonymous } from "./index.js"
import PublicThumbnail from "./PublicThumbnail.js"

export default function PublicNav() {
    const pin = useRequiredContext(PublicProcedureContext)
    const [anonymous, setAnonymouse] = useAnonymous()
    const base = "/" + pin.data.asset.barCode + "/" + pin.data.asset.pin + "/"
    const logOut = () => {
        setAnonymouse(undefined)
    }
    return (
        <Navbar bg="light" className="border-bottom">
            <Container fluid={FLUID_AT}>
                <Maybe value={pin.data.asset.photo} children={upload => <Navbar.Brand><div style={{ width: 32 }}><PublicThumbnail companyId={pin.data.companyId} id={upload.id} upload={upload} /></div></Navbar.Brand>} />
                <Navbar.Brand>
                    <strong>{pin.data.asset.location.name + ASSET_DELIMITER + pin.data.asset.name}</strong>
                </Navbar.Brand>
                <Navbar.Toggle />
                <Navbar.Collapse>
                    <Nav>
                        <Nav.Link to={base + "view"} as={NavLink}><IconText {...VIEW_ICON}>View</IconText></Nav.Link>
                        <Nav.Link to={base + "execute"} as={NavLink}>
                            <IconText {...EXECUTE_ICON}>Execute</IconText>
                            <When condition={pin.data.executions.length > 0}>
                                <Fragment> <Badge bg="danger" className="icon-right">{pin.data.executions.length}</Badge></Fragment>
                            </When>
                        </Nav.Link>
                    </Nav>
                    <Nav className="ms-auto">
                        <Maybe value={anonymous}>
                            {
                                anonymous => {
                                    return (
                                        <Fragment>
                                            <Nav.Item className="p-2">Your Name: <strong>{anonymous.name}</strong> @ <strong>{anonymous.companyName}</strong></Nav.Item>
                                            <Nav.Link onClick={logOut}><IconText {...LOGOUT_ICON}>Log Out</IconText></Nav.Link>
                                        </Fragment>
                                    )
                                }
                            }
                        </Maybe>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}
